import { fetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TEntitlementWithEntityName } from '../entitlement/entitlement.types';

export type TService = {
  invoiceId: string;
  productId: string;
  productName: string;
  entitlements?: TEntitlementWithEntityName;
};

export type TListServicesResponse = {
  services: TService[];
  count: number;
};

interface UseServicesOptions {
  companyId: number;
  limit?: number;
}

export function useServices({ companyId, limit }: UseServicesOptions) {
  const queryParams = new URLSearchParams();
  if (limit) queryParams.append('limit', limit.toString());

  const queryString = queryParams.toString();
  const url = `billing-new/purchased-services/one-time?companyId=${companyId}${queryString ? `&${queryString}` : ''}`;

  return useSWR<TListServicesResponse>(companyId ? url : null, async () => {
    const res = await fetcher(url, { method: 'GET' });
    return res.json();
  });
}
